import React, { Component } from 'react';
import { formatMoney } from '../../slate/currency';
import SizeSelector from './SizeSelector';
import ColorSelector from './ColorSelector';
import { hasSizes, hasColors, colorsForProduct, sizesForProduct, variantsForColor } from '../Product/helpers';
import { find, every, map, filter, uniq, includes } from 'lodash';

function findMatchingVariant(variants, selectedOptions) {
  // Will find a matching variant if and only if all of the
  // provided values exist in the variants options
  return find(variants, v => {
    return v.options === selectedOptions || every(selectedOptions, o => includes(v.options, o));
  });
}

class ProductSelector extends Component {

  constructor(props) {
    super(props);
    this.state = {selectedSize: null};
  }

  selectSize(size) {
    this.setState({ selectedSize: size });
  }

  addToCart = (variantId) => {
    const { addToCart } = this.props;
    addToCart(variantId);
    this.setState({ selectedSize: null });
  }

  onPriceBreakdownClick = (e) => {
    const { priceBreakdownImage, togglePriceModal } = this.props;

    if (priceBreakdownImage) {
      togglePriceModal(e);
    }
  }

  render() {
    const { selectedSize } = this.state;
    const {
      product,
      colorSwatches,
      selectedColor,
      onSelectColor,
      retailPrice,
      isLoading
    } = this.props;

    const doesHaveSizes = hasSizes(product);
    const doesHaveColors = hasSizes(product);

    const variants = doesHaveColors && variantsForColor(product, selectedColor);
    const sizes = doesHaveSizes && sizesForProduct(product);
    const colors = doesHaveColors && colorsForProduct(product);
    const canCheckout = doesHaveSizes ? !!selectedSize : true;

    // Select the variant based on the selection made
    let variant;

    if (product.variants.length === 1) {
      variant = product.variants[0];
    } else {
      variant = findMatchingVariant(variants, [selectedSize, selectedColor]);
    }

    return (
      <div className="product-selection">
        {colors &&
          <div className="product-selection__selector">
            <h3 className="product-selection__selector-header">
              Colour
            </h3>

            <div className="product-selection__selector-items">
              {map(colors, color => {
                // Find the matching color by the name
                const matchingColor = find(colorSwatches, { name: color }) || {};

                return (
                  <ColorSelector
                    key={color}
                    color={matchingColor.name || color}
                    code={matchingColor.color}
                    inStock={every(variants, v => v.available)}
                    isSelected={selectedColor === color}
                    onClick={() => onSelectColor(color)}
                  />
                );
              })}
            </div>
          </div>
        }

        {sizes &&
          <div className="product-selection__selector">
            <h3 className="product-selection__selector-header">
              Size
            </h3>

            <div className="product-selection__selector-items">
              {map(sizes, size => {
                const variantForSize = find(variants, v => v.option1 === size) || {};

                return (
                  <SizeSelector
                    key={size}
                    size={size}
                    inStock={variantForSize.available}
                    isSelected={selectedSize === size}
                    onClick={() => this.selectSize(size)}
                  />
                );
              })}
            </div>
          </div>
        }

        <button
          onClick={() => this.addToCart(variant.id)}
          disabled={!canCheckout || isLoading}
          className="product-selection__add-to-cart"
        >
          {canCheckout ? 'Buy now' : 'Select Size'}
          <span className="product-selection__add-to-cart__price">
            {formatMoney((variant || product).price, window.theme.moneyFormat)}
          </span>
        </button>

        {retailPrice &&
          <a
            href="#"
            className="learn-more-link product-selection__retail-price"
            onClick={this.onPriceBreakdownClick}
          >
            Our price explained
          </a>}
      </div>
    );
  }
}

ProductSelector.defaultProps = {
  price: 0,
  selectedColor: null,
}

export default ProductSelector;



// WEBPACK FOOTER //
// ./assets/scripts/components/ProductSelector/ProductSelector.js